import { render, staticRenderFns } from "./AppAnomaliasLayerControl.vue?vue&type=template&id=87da8b66&scoped=true&"
import script from "./AppAnomaliasLayerControl.vue?vue&type=script&lang=js&"
export * from "./AppAnomaliasLayerControl.vue?vue&type=script&lang=js&"
import style0 from "./AppAnomaliasLayerControl.vue?vue&type=style&index=0&id=87da8b66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87da8b66",
  null
  
)

export default component.exports